import React from 'react';
import { Divider, Modal, Typography } from 'antd';
import EditableTable from "./EditableTableComponent";
const { Title } = Typography;

const ListModel = ({ visible, handleCancel , body ,title, userId , subCollectionName}) => {
  return (
    <Modal 
      title = {<Title level={4} className="text-primary fw-bold mb-0 text-uppercase">{title}</Title>}
      centered
      open={visible}
      onCancel={handleCancel}
      destroyOnHidden={true}
      width="60%"
      zIndex={99999}
      footer={null}
    >
      <div>
      <Divider />
           <EditableTable data={body} userId={userId}  subCollectionName={subCollectionName} modelClose={handleCancel}/>
       </div>
    </Modal >
  );
};

export default ListModel;